const { equals } = require(`ramda`)

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const DEPLOY_ENV = process.env.ACTIVE_ENV || `development`

const doesBuildEqual = equals(DEPLOY_ENV)

const isProductionBuild = () => doesBuildEqual(`production`)
const isStagingBuild = () => doesBuildEqual(`staging`)
const isTestBuild = () => doesBuildEqual(`test`)
const isDevelopmentBuild = () => doesBuildEqual(`development`)

const getEnvPath = (env) => `.env.${env}`

module.exports = {
  isProductionBuild,
  isStagingBuild,
  isTestBuild,
  isDevelopmentBuild,
  getEnvPath,
}
